import { render, staticRenderFns } from "./PlantaoConfirm.vue?vue&type=template&id=55292748&scoped=true"
import script from "./PlantaoConfirm.vue?vue&type=script&lang=js"
export * from "./PlantaoConfirm.vue?vue&type=script&lang=js"
import style0 from "./PlantaoConfirm.vue?vue&type=style&index=0&id=55292748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55292748",
  null
  
)

export default component.exports